






























































































































































































































































































































































































































import {
	AccountTypeEnum,
	GrouppedAdditionEnum,
	PredicateDefinition,
	ProjectionAggregationEnum,
	QueryOperator,
	TenantUserModel,
	WorkTaskStatementModel
} from '@/libs/Api';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import {useObjectKey} from '@/libs/common/functions/use-object-key';
import {createAggregationQueryPayload} from '@/libs/core/+state/models/aggregation-query-payload';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudDataStats} from '@/libs/core/+state/models/crud-data-stats';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload, createGrouppedQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {CrudQueryPredicate} from '@/libs/core/+state/models/crud-query-predicate';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import StatementDetailDialog from '../components/StatementDetailDialog.vue';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {CrudOrderBy} from '@/libs/core/+state/models/crud-order-by';
import StatementsDialog from "@/libs/statements/components/StatementsDialog.vue";
import { Filters, PageFilter } from '@/filters';
import {DateRangeValue} from "@/libs/common/components/DateRangePicker.vue";

@Component({
    components: {
		StatementsDialog,
        StatementDetailDialog
    }
})
export default class Statements extends Page {
    
    filterStart: DateRangeValue | null = null;
    filterParty: string | null = "";
    filterState: string | null = "";
    filterUser: string | null = "";
    filterTown: string | null = "";
    filterDistrict: string | null = "";
    filterPaymentMethod: string | null = "";
    filterType: string | null = "";
    pageInitialization = true;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "workTask.time" ];
    sortDesc = [ true ];
	view = "byClient";

	get headersByClient() {
		return [
			{ text: this.$i18n.t("statements.columnClient"), value: "workTask.partyWorkDay.party.lastName", align: "left", width: "10%" },
			{ text: "Počet úkonů", value: "count", align: "left", width: "5%" },
			{ text: this.$i18n.t("statements.columnPrice"), value: "totalPrice", align: "left", width: "5%" },
			//{ text: this.$i18n.t("statements.columnPaymentMethod"), value: "workTask.partyWorkDay.party.paymentMethod.position", align: "left", width: "8%" },
			{ text: this.$i18n.t("statements.columnDistrict"), value: "workTask.partyWorkDay.party.district.name", align: "left", width: "7%" },
			{ text: this.$i18n.t("statements.columnTown"), value: "workTask.partyWorkDay.party.town.name", align: "left", width: "7%" },
			{ text: "", value: "id", align: "left", width: "5%" },
		];
	}

    get headersByWorkTask() {
        return [
            { text: this.$i18n.t("statements.columnDate"), value: "workTask.time", align: "left", width: "5%" },
            { text: this.$i18n.t("statements.columnClient"), value: "workTask.partyWorkDay.party.lastName", align: "left", width: "10%" },
            { text: this.$i18n.t("statements.columnSocialWorker"), value: "user.lastName", align: "left", width: "8%" },
            { text: this.$i18n.t("statements.columnTask"), value: "workTask.catalogueItem.name", align: "left" },
			{ text: "Pravidelnost úkonu", value: "workTask.workTaskRule.frequency", align: "left" },
            { text: this.$i18n.t("statements.columnPricePerUnit"), value: "workTask.unitPrice", align: "left", width: "8%" },
            { text: this.$i18n.t("statements.columnAmount"), value: "amount", align: "left", width: "5%" },
            { text: "Návštěva", value: "visitNumber", align: "left", width: "5%" },
            { text: "Typ tarifu", value: "workTask.partyPeriod.isLoweredUnitPrice", align: "left", width: "5%" },
            { text: this.$i18n.t("statements.columnPrice"), value: "price", align: "left", width: "5%" },
            //{ text: this.$i18n.t("statements.columnPaymentMethod"), value: "workTask.partyWorkDay.party.paymentMethod.position", align: "left", width: "8%" },
            { text: this.$i18n.t("statements.columnDistrict"), value: "workTask.partyWorkDay.party.district.name", align: "left", width: "7%" },
            { text: this.$i18n.t("statements.columnTown"), value: "workTask.partyWorkDay.party.town.name", align: "left", width: "7%" },
            { text: "", value: "id", align: "left", width: "5%" },
        ];
    }

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() exportDialog!: ExportDialog;
    @Ref() dialog!: StatementDetailDialog;
    @Ref() statementsDialog!: StatementsDialog;

    @Watch("filterStart")
    @Watch("filterState")
    @Watch("filterParty")
    @Watch("filterUser")
    @Watch("filterTown")
    @Watch("filterDistrict")
    @Watch("filterPaymentMethod")
    @Watch("filterType")
    @Watch("view")
    filtersChanged (v: string, p: string) {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            this.load();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    get workTaskStatements () {
        return [...workTaskStatementsStore.useGetter(CrudGetter.Data)];
    }

    get grouppedWorkTaskStatements () {
        return [...workTaskStatementsStore.useGetter(CrudGetter.GrouppedData)];
    }

    get grouppedWorkTaskStatementsTotalPrice () {
        return [...workTaskStatementsStore.useGetter(CrudGetter.GrouppedData)]?.select(x => x.totalPrice ?? 0).sum();
    }

    get totalRows (): number {
        return ({...workTaskStatementsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get moneySum () {
        return workTaskStatementsStore.useGetter(CrudGetter.Sum);
    }

    get exporting(): boolean {
        return workTaskStatementsStore.useGetter(CrudGetter.Downloading);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get loading () {
        return workTaskStatementsStore.useGetter(CrudGetter.Pending);
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    mounted () {
        this.load();
    }

    saveQuery () {
        this.setQuery("datetype", this.filterStart?.type ?? null);
        this.setQuery("start", moment(this.filterStart?.fromDate).format("YYYY-MM-DD"));
        this.setQuery("end", moment(this.filterStart?.toDate).format("YYYY-MM-DD"));
        this.setQuery("state", this.filterState);
        this.setQuery("party", this.filterParty);
        this.setQuery("user", this.filterUser);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("paymentMethod", this.filterPaymentMethod);
        this.setQuery("type", this.filterType);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'Statements',
            filters: [
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'user', value: this.filterUser },
                { name: 'paymentMethod', value: this.filterPaymentMethod },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
        const globalFilters: PageFilter = {
            pageName: 'Global',
            filters: [
                { name: 'datetype', value: this.filterStart?.type ?? null },
                { name: 'start', value: moment(this.filterStart?.fromDate).format("YYYY-MM-DD") },
                { name: 'end', value: moment(this.filterStart?.toDate).format("YYYY-MM-DD") },
            ]
        };
        Filters.saveFilters(globalFilters);
    }

    clearFilters () {
        this.filterStart = {
            type: "period",
            fromDate: moment().add(-1, "month").startOf("month").format("YYYY-MM-DDT00:00:00"),
            toDate: moment().add(-1, "month").endOf("month").format("YYYY-MM-DDT23:59:59")
        };
        this.filterState = null;
        this.filterParty = null;
        this.filterUser = null;
        if (this.isAdmin) {
            this.filterDistrict = null;
        }
        this.filterTown = null;
        this.filterPaymentMethod = null;
        this.filterType = null;
        this.saveQuery();
    }

    created () {
        if (this.getQuery("start") != null || this.getQuery("end") != null || this.getQuery("state") != null || this.getQuery("party") != null || this.getQuery("user") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("paymentMethod") != null || this.getQuery("type") != null || this.getQueryInt("pageSize") != null) {
            if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterState = this.getQuery("state") ?? "";
            this.filterParty = this.getQuery("party") ?? "";
            this.filterUser = this.getQuery("user") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.filterPaymentMethod = this.getQuery("paymentMethod") ?? "";
            this.filterType = this.getQuery("type") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterParty = Filters.loadFilter('Statements', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('Statements', 'district') ?? null;
            this.filterTown = Filters.loadFilter('Statements', 'town') ?? null;
            this.filterUser = Filters.loadFilter('Statements', 'user') ?? null;
            this.filterPaymentMethod = Filters.loadFilter('Statements', 'paymentMethod') ?? null;
            this.pageSize = Number(Filters.loadFilter('Statements', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    load () {
		if (this.view === "byClient") {
			workTaskStatementsStore.dispatch(CrudAction.GetGroupped, createGrouppedQueryPayload<WorkTaskStatementModel>(this.getFilters() as PredicateDefinition[], [
				{ field: "workTask.partyWorkDay.partyId" }
			], [
				{ field: "Id", aggregation: ProjectionAggregationEnum.Count, outputField: "Count" },
				{ field: "Price", aggregation: ProjectionAggregationEnum.Sum, outputField: "TotalPrice" }
			], [
				{ additionType: GrouppedAdditionEnum.PartyBasic, keyField: "partyId", outputName: "Party" }
			]));
			this.subscribe(workTaskStatementsStore, CrudReponse.GetGroupped).then(() => {
				this.pageInitialization = false;
			});
		}
		else {
			const orderBy: CrudOrderBy<WorkTaskStatementModel>[] = [];
			if (this.sortBy.length == 0) {
				orderBy.push({
					field: "workTask.time",
					index: 1,
					order: "desc"
				});
			}
			else {
				orderBy.push({
					field: this.sortBy.first(),
					index: 1,
					order: this.sortDesc.first() ? "desc" : "asc"
				});
			}
			workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>(orderBy, this.getFilters(), {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			}));
			this.subscribe(workTaskStatementsStore, CrudReponse.GetAll).then(() => {
				this.pageInitialization = false;
			});
		}
        this.loadSum();
    }

    loadSum () {
        workTaskStatementsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(this.getFilters(), useObjectKey<WorkTaskStatementModel>("price")))
    }

    getFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [];
        
        if (this.filterStart?.fromDate) {
            filters.push({
                field: "workTask.time",
                op: QueryOperator.Gte,
                comparand: moment(this.filterStart.fromDate).format("YYYY-MM-DDT00:00:00")
            });
        }
        
        if (this.filterStart?.toDate) {
            filters.push({
                field: "workTask.time",
                op: QueryOperator.Lte,
                comparand: moment(this.filterStart.toDate).format("YYYY-MM-DDT23:59:59")
            });
        }
        
        if (this.filterParty) 
            filters.push({ field: "workTask.partyWorkDay.partyId", op: "eq", comparand: this.filterParty });
        
        if (this.filterState) 
            filters.push({ field: "workTask.partyWorkDay.party.clientStateId", op: "eq", comparand: this.filterState });
        
        if (this.filterUser) 
            filters.push({ field: "userId", op: "eq", comparand: this.filterUser });
        
        if (this.filterDistrict) 
            filters.push({ field: "workTask.partyWorkDay.party.districtId", op: "eq", comparand: this.filterDistrict });

        if (this.filterTown) 
            filters.push({ field: "workTask.partyWorkDay.party.townId", op: "eq", comparand: this.filterTown });

        if (this.filterPaymentMethod) 
            filters.push({ field: "workTask.partyWorkDay.party.paymentMethodId", op: "eq", comparand: this.filterPaymentMethod });
        
        if (this.filterType) 
            filters.push({ field: "workTask.catalogueItem.billingType", op: "eq", comparand: this.filterType });

        return filters;

    }

    getPayload() {
        return createCrudQueryPayload<WorkTaskStatementModel>({ field: "WorkTask.Time", index: 1, order: "asc"}, this.getFilters());
    }

    exportClick () {
        this.exportDialog.open();
    }

    exportDownload () {
        workTaskStatementsStore.dispatch(CrudAction.Download, this.getPayload());
        this.subscribe(workTaskStatementsStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

    openStatement (item: WorkTaskStatementModel) {
        this.dialog.open(item.id!);
    }

	openStatementList(item: any) {
		this.statementsDialog.open(item.key.partyId, this.getFilters() as PredicateDefinition[]);
	}

    createStatement () {
        this.dialog.create();
    }

}
